import Vue from 'vue'
import Vuex from 'vuex'
import ibeData from './ibeData'
import currentSelection from './currentSelection'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    ibeData: ibeData,
    currentSelection: currentSelection
  }
})
